// GAVION task actions: who « Courriel » writes to when the task has no contact of its own.
import { firstEmail } from "../integrations/compose/composeModel";
import type { TaskContact } from "./taskActionTypes";

/**
 * The contact « Courriel » addresses: the task's own contact, else the deal's first contact, else the first
 * contact of the compagnie that has an email (rows in the order given). Null when none applies.
 */
export function resolveTaskContact(
  own: TaskContact | null | undefined,
  dealContact: TaskContact | null | undefined,
  companyContacts: readonly TaskContact[] | null | undefined,
): TaskContact | null {
  if (own) return own;
  if (dealContact) return dealContact;
  return companyContacts?.find((c) => firstEmail(c).length > 0) ?? null;
}
